import { useApiMutation, useApiQuery } from "@/hooks/use-api";
import {
  Conversation,
  ConversationCreate,
  ConversationUpdate,
} from "@/models/conversation";

/**
 * Hook to fetch all conversations for the current workspace.
 */
export const useConversations = () =>
  useApiQuery<Conversation[]>({ url: "conversations" });

/**
 * Hook to fetch a single conversation by ID.
 * @param id - The conversation ID
 */
export const useConversation = (id?: string) =>
  useApiQuery<Conversation>(
    { url: `conversations/${id}` },
    { enabled: !!id }
  );

/**
 * Hook to create a new conversation.
 */
export const useCreateConversation = () =>
  useApiMutation<Conversation, ConversationCreate>({
    url: "conversations",
    method: "POST",
  });

/**
 * Hook to update an existing conversation.
 */
export const useUpdateConversation = () =>
  useApiMutation<Conversation, ConversationUpdate, { id: string }>({
    url: "conversations/{id}",
    method: "PATCH",
  });

/**
 * Hook to delete a conversation.
 */
export const useDeleteConversation = () =>
  useApiMutation<void, object, { id: string }>({
    url: "conversations/{id}",
    method: "DELETE",
  });
